export default __webpack_public_path__ + "static/media/Graphik-Medium.870f914f.otf";